var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrderOperators = function SvgOrderOperators(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M1.996 20.003v-1.017C1.996 16.785 3.78 15 5.98 15h4.036c2.201 0 3.985 1.784 3.985 3.985v1.017m3.001-5.002h1.103a3.984 3.984 0 0 1 3.984 3.985v1.017M11.49 8.51a3.491 3.491 0 1 1-6.982 0 3.491 3.491 0 0 1 6.983 0m8.014.99a2.501 2.501 0 1 1-5.002 0 2.501 2.501 0 0 1 5.002 0",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgOrderOperators;